module.exports = __webpack_public_path__ + "static/media/24WingChunAcademyLR-176.68741727.jpg";